__turbopack_context__.v({
  "menuActiveIcon": "CategoryNav-module-scss-module__K6-Tra__menuActiveIcon",
  "menuActiveItemLink": "CategoryNav-module-scss-module__K6-Tra__menuActiveItemLink",
  "menuCount": "CategoryNav-module-scss-module__K6-Tra__menuCount",
  "menuIsRefined": "CategoryNav-module-scss-module__K6-Tra__menuIsRefined",
  "menuLink": "CategoryNav-module-scss-module__K6-Tra__menuLink",
  "menuList": "CategoryNav-module-scss-module__K6-Tra__menuList",
  "menuParentItem": "CategoryNav-module-scss-module__K6-Tra__menuParentItem",
  "menuParentItemInactive": "CategoryNav-module-scss-module__K6-Tra__menuParentItemInactive",
  "menuRoot": "CategoryNav-module-scss-module__K6-Tra__menuRoot",
  "menuSelectedItemLink": "CategoryNav-module-scss-module__K6-Tra__menuSelectedItemLink",
  "viewAllLink": "CategoryNav-module-scss-module__K6-Tra__viewAllLink",
});
